<template>
	<div class="reference">
		<div class="img_container">
			<img class="img1" src="../assets/img/index/黄色背景图1.jpg" alt="引用文献" />
			<div class="chn_title">
				<div>※引用文献</div>
			</div>
			<div class="eng_title">
				<div>REFERENCE CITED</div>
			</div>
		</div>
		<div id="title" class="cited_title">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p class="chn_cited_title">成像仪</p>
		</div>
		<div class="reference_cited1">
			<el-table :data="imaging_device" border stripe
				:header-cell-style="{'text-align':'center','height':'60px','backgroundColor':'#fff00699','font-size':'18px','color':'rgb(35, 24, 21)'}"
				:cell-style="{'height':'80px'}" style="width: 100%;">
				<el-table-column prop="id" label="序号" min-width="5%" align="center">
				</el-table-column>
				<el-table-column prop="title" label="标题" min-width="35%">
				</el-table-column>
				<el-table-column prop="journal" label="期刊名称" min-width="15%" align="center">
				</el-table-column>
				<el-table-column prop="product" label="产品名称" min-width="15%" align="center">
				</el-table-column>
				<el-table-column prop="link" label="链接" min-width="30%">
				</el-table-column>
			</el-table>
		</div>
		<div class="reference_cited11">
			<el-table :data="imaging_device" border stripe
				:header-cell-style="{'text-align':'center','height':'60px','backgroundColor':'#fff00699','font-size':'15px','color':'rgb(35, 24, 21)'}"
				:cell-style="{'height':'80px'}" style="width: 100%;margin-bottom: 1rem;">
				<el-table-column prop="id" label="序号" min-width="9%" align="center">
				</el-table-column>
				<el-table-column prop="title" label="标题" min-width="35%">
				</el-table-column>
				<el-table-column prop="journal" label="期刊名称" min-width="15%" align="center">
				</el-table-column>
				<el-table-column prop="product" label="产品名称" min-width="13%" align="center">
				</el-table-column>
				<el-table-column prop="link" label="链接" min-width="28%">
				</el-table-column>
			</el-table>
		</div>
		<div id="title" class="cited_title">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p class="chn_cited_title">计数仪</p>
		</div>
		<div class="reference_cited2">
			<el-table :data="counter_device" border stripe
				:header-cell-style="{'text-align':'center','height':'60px','backgroundColor':'#fff00699','font-size':'18px','color':'rgb(35, 24, 21)'}"
				:cell-style="{'height':'80px'}" style="width: 100%;">
				<el-table-column prop="id" label="序号" min-width="5%" align="center">
				</el-table-column>
				<el-table-column prop="title" label="标题" min-width="35%">
				</el-table-column>
				<el-table-column prop="journal" label="期刊名称" min-width="15%" align="center">
				</el-table-column>
				<el-table-column prop="product" label="产品名称" min-width="15%" align="center">
				</el-table-column>
				<el-table-column prop="link" min-width="30%" label="链接">
				</el-table-column>
			</el-table>
		</div>
		<div class="reference_cited22">
			<el-table :data="counter_device" border stripe
				:header-cell-style="{'text-align':'center','height':'60px','backgroundColor':'#fff00699','font-size':'15px','color':'rgb(35, 24, 21)'}"
				:cell-style="{'height':'80px'}" style="width: 100%;margin-bottom: 5rem;">
				<el-table-column prop="id" label="序号" min-width="9%" align="center">
				</el-table-column>
				<el-table-column prop="title" label="标题" min-width="35%">
				</el-table-column>
				<el-table-column prop="journal" label="期刊名称" min-width="14%" align="center">
				</el-table-column>
				<el-table-column prop="product" label="产品名称" min-width="12%" align="center">
				</el-table-column>
				<el-table-column prop="link" min-width="28%" label="链接">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import { imagingDevice, counterDevice } from '../constants/references'
	export default {
		name: 'Reference',
		data() {
			return {
				imaging_device: imagingDevice,
				counter_device: counterDevice
			}
		}
	}
</script>

<style scoped>
	.img_container {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.img1 {
		width: 100%;
		height: 450px;
	}

	.chn_title {
		position: absolute;
		color: rgb(35, 24, 21);
		margin-right: 600px;
		margin-bottom: 50px;
		font-size: 50px;
		transform: translate(-40%, -40%);
		letter-spacing: 1px;
	}

	.eng_title {
		position: absolute;
		margin-right: 800px;
		margin-top: 50px;
		color: rgb(35, 24, 21);
		font-size: 20px;
		font-weight: 400;
		letter-spacing: 3px;
		font-family: Rany Light;
	}

	.reference_cited1 {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 100px;
		transform: translateY(-80px);
	}

	.reference_cited2 {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 100px;
		transform: translateY(-80px);
	}

	/deep/ .el-table .el-table__row:nth-child(odd) {
		background-color: #ffffff !important;
		/* 淡灰色 */
	}

	/deep/ .el-table .el-table__row:nth-child(even) {
		/* background-color: #fff006 !important; */
		/* 淡黄色 */
	}

	.el-table__body {
		width: 100% !important;
	}

	#title {
		margin-left: 100px;
	}

	.cited_title {
		display: flex;
		align-items: center;
		margin-top: 8vh;
	}
	.chn_cited_title {
		font-size: 30px;
		font-weight: 500;
		margin-left: 10px;
	}

	.reference_cited11 {
		display: none;
	}

	.reference_cited22 {
		display: none;
	}

	.icon1 {
		width: 33px;
		height: auto;
	}

	@media screen and (max-width: 1150px) {
		.img1 {
			width: 100%;
			height: auto;
		}

		.chn_title {
			margin-right: 400px;
			font-size: 2rem;
		}

		.eng_title {
			margin-right: 530px;
			margin-top: 30px;
			font-size: 0.8rem;
		}
	}

	@media screen and (max-width: 800px) {
		.img1 {
			height: calc(150px + 10vw);
			width: 100%;
		}

		.chn_title {
			margin-right: 100px;
			margin-top: 40px;
			font-size: 1.2rem;
		}

		.eng_title {
			margin-right: 165px;
			margin-top: 40px;
			font-size: 0.6rem;
			letter-spacing: 2px;
		}

		#title {
			margin-left: 20px;
		}

		.reference_cited1 {
			display: none;
		}

		.reference_cited2 {
			display: none;
		}

		.reference_cited11 {
			display: block;
		}

		.reference_cited22 {
			display: block;
		}

		.cited_title {
			margin-top: 3vh;
		}
		
		.chn_cited_title {
			font-size: 1.2rem;
			font-weight: 500;
			margin-left: 10px;
		}

		.icon1 {
			width: 25px;
			height: auto;
		}
	}
</style>